import { getField, updateField } from 'vuex-map-fields'
import BaseStore from './baseStore'
import BaseDirtyFields from './baseDirtyFields'
import { LoadAreaPlot, LoadSpreadPlot } from '@/plotData/uniformLoads'
import { lineString, lineIntersect } from '@turf/turf'
import { generateMultipleItemOverview } from '@/store/baseOverview'

export const namespaced = true

let baseUrl = '/uniform_loads/'

const baseStore = new BaseStore(baseUrl)
const baseDirtyFields = new BaseDirtyFields()
const baseOverview = generateMultipleItemOverview({
  itemFilter: (uniformLoad, stabSchematisationStage) =>
    uniformLoad.stage === stabSchematisationStage.id,
  duplicationCheckFunc: (uniformLoad, stabSchematisationStageId) =>
    uniformLoad.stage === stabSchematisationStageId
})

const getDefaultState = () => {
  return {
    ...structuredClone(baseStore.state),
    ...structuredClone(baseDirtyFields.state),
    uniformLoadsOverview: []
  }
}
export const state = {
  ...getDefaultState(),
  ...structuredClone(baseOverview.state)
}

export const mutations = {
  ...baseStore.mutations,
  ...baseDirtyFields.mutations,
  ...baseOverview.mutations,
  updateField,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  }
}
export const actions = {
  ...baseStore.actions,
  ...baseDirtyFields.actions,
  ...baseOverview.actions,
  resetState({ commit }) {
    commit('RESET_STATE')
  }
}

export const getters = {
  ...baseOverview.getters,
  getField,
  getPlotData:
    (state, getters, rootState, rootGetters) =>
    (stabSchematisationStage = null) => {
      let storeName = 'uniformLoads'
      let polygon = []
      const topoProfileGeometry =
        rootGetters['topoProfilePoint/getTopoProfileGeometry'](stabSchematisationStage)
      const getItem = rootGetters['topoProfilePoint/getItem']
      const items = getters.getItemsByStabSchematisationStage(stabSchematisationStage)
      topoProfileGeometry && topoProfileGeometry.length
        ? items.forEach((item) => {
            if (item.topo_profile_point === null) {
              return
            }
            let topoProfilePointX = item.topo_profile_point
              ? getItem(item.topo_profile_point).geometry.coordinates[0]
              : 0
            let start = item.start + topoProfilePointX
            let end = item.end + topoProfilePointX
            let [intersectLineStart, intersectLineEnd] = getters.getInterSectionLines({
              itemStart: start,
              itemEnd: end,
              stabSchematisationStage
            })
            let pointStart = getters.calculatePoint(topoProfileGeometry, intersectLineStart)
            let pointEnd = getters.calculatePoint(topoProfileGeometry, intersectLineEnd)

            let height = item.magnitude / 10

            let plotItem = new LoadAreaPlot(item, 'uniform_load_', 'toself') // TODO refactor more when
            plotItem.extractPolygonFromLine(pointStart, pointEnd, height, topoProfileGeometry)
            plotItem.storeName = storeName
            polygon.push(plotItem)

            let plotSpreadItemStart = new LoadSpreadPlot(item) // TODO refactor more when
            let plotSpreadItemEnd = new LoadSpreadPlot(item, true) // TODO refactor more when
            let spread = item.spread + 135
            plotSpreadItemStart.create(pointStart, spread, height)
            plotSpreadItemStart.storeName = storeName
            plotSpreadItemEnd.create(pointEnd, spread, height)
            plotSpreadItemEnd.storeName = storeName
            polygon.push(plotSpreadItemStart, plotSpreadItemEnd)
          })
        : null
      return polygon
    },

  getInterSectionLines:
    (state, getters, rootState, rootGetters) =>
    ({ itemStart, itemEnd, stabSchematisationStage }) => {
      const plotDataMaxY = rootGetters['topoProfilePoint/getPlotDataMaxY'](stabSchematisationStage)
      const plotDataMinY = rootGetters['topoProfilePoint/getPlotDataMinY'](stabSchematisationStage)
      const plotDataMaxX = rootGetters['topoProfilePoint/getPlotDataMaxX'](stabSchematisationStage)
      const plotDataMinX = rootGetters['topoProfilePoint/getPlotDataMinX'](stabSchematisationStage)
      let xStart = itemStart < plotDataMinX ? plotDataMinX : itemStart
      let xEnd = itemEnd > plotDataMaxX ? plotDataMaxX : itemEnd
      let intersectLineStart = [
        [xStart, plotDataMinY],
        [xStart, plotDataMaxY]
      ]
      let intersectLineEnd = [
        [xEnd, plotDataMinY],
        [xEnd, plotDataMaxY]
      ]
      return [intersectLineStart, intersectLineEnd]
    },
  calculatePoint: () => (topoProfileGeometry, line2) => {
    var line1 = lineString(topoProfileGeometry)
    var intersects = lineIntersect(line1, lineString(line2))
    return intersects.features[0].geometry.coordinates
  }
}
